<div class="login-register">
    <div class="login-side">
        <div class="login-side-logo">
            <div class="m-b-3">
                <img alt="homepage" src="assets/images/logo-light-icon.png" />
            </div>
        </div>
        <div class="login-side-box">
            <div class="login-side-legend">
                <h2 class="m-t-0 m-b-0 text-white">Software</h2>
                <h2 class="m-t-0 m-b-0 text-white">para la gestión de</h2>
                <h2 class="m-t-0 m-b-0 text-white">Remates en vivo</h2>
            </div>
        </div>
    </div>
    <div class="login-register-box">
        <mat-card class="m-t-10">
            <mat-card-content>
                <form id="loginform">
                    <div class="text-center">
                        <img alt="homepage" src="assets/images/logo-icon.png" />
                        <h4 class="m-t-0">Ingreso</h4>
                    </div>
                    <div *ngIf="msg" class="bg-danger p-10 text-white">{{ msg }}</div>
                    <div fxLayout="row wrap">
                        <!-- col full-->
                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <mat-form-field>
                                <input matInput placeholder="Usuario" required="" #u1 />
                            </mat-form-field>
                        </div>
                        <!-- col full-->
                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <mat-form-field>
                                <input matInput type="password" placeholder="Contraseña" required="" #p2 />
                            </mat-form-field>
                        </div>
                        <!-- col full-->
                        <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <app-action-loader #loginLoader [wrapperFullWidth]="true">
                                <button
                                    mat-raised-button
                                    color="primary"
                                    class="btn-block btn-lg"
                                    (click)="check(u1.value, p2.value)"
                                    [disabled]="loginLoader.isRunning"
                                    type="button"
                                >
                                    Login
                                </button>
                            </app-action-loader>
                        </div>

                        <div class="password-remember" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                            <a class="text-primary" href="javascript:void(0)" (click)="onRememberPwd()"
                                >Recordar Contraseña</a
                            >
                            <span id="version">v5.0.0</span>
                        </div>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
